(function(){
  var S = window.SanitaerSuche;
  if(!S) return;
  var idxPromise = null, MONEY='EUR';
  try { if(window.Shopify && Shopify.currency && Shopify.currency.active) MONEY = Shopify.currency.active; } catch(e){}

  function fmt(cents){
    if(cents==null) return '';
    try { return new Intl.NumberFormat('de-DE',{style:'currency',currency:MONEY}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2).replace('.',',')+' €'; }
  }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function debounce(fn,ms){ var t; return function(){ var a=arguments,c=this; clearTimeout(t); t=setTimeout(function(){fn.apply(c,a);},ms); }; }

  function loadIndex(){
    if(!idxPromise) idxPromise = S.loadIndex();
    return idxPromise;
  }
  function build(input){
    if(input.dataset.psDone) return; input.dataset.psDone='1';
    input.setAttribute('autocomplete','off');
    var form = input.closest('form') || input.parentElement;
    var url = form.getAttribute('action') || '/search';
    var box = document.createElement('div');
    box.className='predictive-search predictive-search--fixed'; box.hidden=true;
    document.body.appendChild(box);
    var items = null;

    function position(){
      var r = input.getBoundingClientRect();
      box.style.top = (r.bottom + 6) + 'px';
      box.style.left = r.left + 'px';
      box.style.width = r.width + 'px';
    }
    function close(){ box.hidden=true; box.innerHTML=''; }
    window.addEventListener('scroll', function(){ if(!box.hidden) position(); }, {passive:true});
    window.addEventListener('resize', function(){ if(!box.hidden) position(); });
    function render(results, q){
      if(!results.length){
        box.innerHTML='<div class="ps-empty">Keine Treffer für „'+esc(q)+'“. Prüfe die Schreibweise oder Artikelnummer.</div>';
        position(); box.hidden=false; return;
      }
      var html = results.map(function(p){
        var img=S.bild(p.i,120);
        return '<a class="ps-item" href="/products/'+esc(p.h)+'">'+
          (img?'<img class="ps-item__img" src="'+esc(img)+'" alt="" loading="lazy">':'<span class="ps-item__img"></span>')+
          '<span class="ps-item__txt"><span class="ps-item__title">'+esc(p.t)+'</span>'+
          (p.s?'<span class="ps-item__sku">Art-Nr. '+esc(p.s.split(' ')[0])+'</span>':'')+'</span>'+
          (p.p!=null?'<span class="ps-item__price">'+esc(fmt(p.p))+'</span>':'')+'</a>';
      }).join('');
      html += '<a class="ps-all" href="'+esc(url)+'?q='+encodeURIComponent(q)+'">Alle Ergebnisse für „'+esc(q)+'“ →</a>';
      box.innerHTML=html; position(); box.hidden=false;
    }

    var run = debounce(function(){
      var q=input.value.trim();
      if(q.length<2){ close(); return; }
      loadIndex().then(function(loaded){
        items=loaded;
        render(S.search(items, q, 8), q);
      });
    },120);

    input.addEventListener('input', run);
    input.addEventListener('focus', function(){ if(input.value.trim().length>=2) run(); });
    document.addEventListener('click', function(e){ if(!form.contains(e.target) && !box.contains(e.target)) close(); });
    input.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
  }

  function init(){
    var inputs = document.querySelectorAll('form[action$="/search"] input[name="q"], .search-form input[name="q"]');
    inputs.forEach(build);
    loadIndex();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
